import { useForm } from 'react-hook-form';
import { EmailChangeData } from '../types';
import { api } from '../api';
import { useAccount } from '../hooks';
import { Field, Input, Label } from '@headlessui/react';
import { Button } from '../../ui/components/Button';

type Props = {
  onSuccess: () => void,
  onFailure: (error: object) => void
}

export const EmailChangeForm = ({ onFailure, onSuccess }: Props) => {

  const account = useAccount();
  const {
    register,
    handleSubmit,
    formState: { isSubmitting }
  } = useForm<EmailChangeData>({
    defaultValues: {
      email: account?.email
    }
  });
  const [changeEmail] = api.useChangeEmailMutation();

  const doSubmit = (data: EmailChangeData) => {
    changeEmail(data).unwrap().then(onSuccess).catch(onFailure);
  };

  return (
    <div className='grow my-4 p-4'>
      <h3 className='text-lg my-4'>Change email</h3>
      <form
        className='pl-4 grid grid-cols-[auto_1fr] gap-4 items-center'
        onSubmit={handleSubmit(doSubmit)}
      >
        <p className='text-sm col-span-2 text-neutral-500'>
          Use this form to change the email address associated with your
          account. You'll use the new email address to log in.
        </p>
        <Field className='grid grid-cols-subgrid col-span-2 items-center'>
          <Label className='inline'>New email</Label>
          <Input
            {...register('email', { required: true })}
            autoComplete='email'
            className='border border-jw-blue'
            type='email'
          />
        </Field>
        <Button
          className='col-span-2 justify-self-start'
          disabled={isSubmitting}
          type='submit'
        >
          Change email
        </Button>
      </form>
    </div>
  );
};
